export const easeInOutSine = (x) => -(Math.cos(Math.PI * x) - 1) / 2

export const easeInOutQuad = (x) => (x < 0.5 ? 2 * x * x : 1 - Math.pow(-2 * x + 2, 2) / 2)
